export default __webpack_public_path__ + "static/media/card-image.ca564b55.png";